import { DayOfWeekEnum } from '@nxsys/constants/AppEnums';

// Kept out of WorkingPatternForm.tsx so that file only exports components
// (react-refresh/only-export-components).
export const WORKING_PATTERN_OPTIONS = [
  { label: 'Monday', value: DayOfWeekEnum.MONDAY },
  { label: 'Tuesday', value: DayOfWeekEnum.TUESDAY },
  { label: 'Wednesday', value: DayOfWeekEnum.WEDNESDAY },
  { label: 'Thursday', value: DayOfWeekEnum.THURSDAY },
  { label: 'Friday', value: DayOfWeekEnum.FRIDAY },
  { label: 'Saturday', value: DayOfWeekEnum.SATURDAY },
  { label: 'Sunday', value: DayOfWeekEnum.SUNDAY },
];
